import { render, staticRenderFns } from "./c1Header.vue?vue&type=template&id=106ff97a&scoped=true"
import script from "./c1Header.vue?vue&type=script&lang=js"
export * from "./c1Header.vue?vue&type=script&lang=js"
import style0 from "./c1Header.vue?vue&type=style&index=0&id=106ff97a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ff97a",
  null
  
)

export default component.exports